import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="floading-container">
      <div className="floading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
